// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from "./AuthContext"; 
import LandingPage from './essentials/LandingPage';
import VideoSlideGenerator from './main-pages/VideoSlideGenerator';
import Header from './essentials/Header';
import { ThemeProvider } from './ThemeContext';
import ResourcesPage from './legal-pages/ResourcesPage';
import PricingPage from './essentials/PricingPage';
import Profile from './essentials/Profile';
import Footer from './essentials/Footer';
import PrivacyPolicy from "./legal-pages/PrivacyPolicy";
import RefundPolicy from "./legal-pages/RefundPolicy";
import FAQ from "./legal-pages/FAQ";
import TermsOfService from "./legal-pages/TermsOfService";
import ContactAndSupport from "./legal-pages/ContactandSupport";
import SharedPresentationView from './main-pages/SharedPresentationView';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* ✅ SHARED VIEW - No Header/Footer, Full Screen */}
            <Route 
              path="/shared/:shareId" 
              element={<SharedPresentationView />} 
            />

            {/* ✅ ALL OTHER ROUTES - With Header/Footer */}
            <Route path="*" element={
              <div className="App">
                <Header />
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/generate" element={<VideoSlideGenerator />} />
                  <Route path="/pricing-plans" element={<PricingPage />} />
                  <Route path="/resources-help" element={<ResourcesPage />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                  <Route path="/termsofservice" element={<TermsOfService />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/faq-support" element={<FAQ />} />
                  <Route path="/contact-support" element={<ContactAndSupport />} />
                </Routes>
                <Footer />
              </div>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;